import React from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';

import withIntl from '../../../lib/withIntl';

import './TipLifetime.scss';

function TipLifetime({intl}) {
  return (
    <div className="tip-lifetime">
      <FmlxTooltip title={intl.formatMessage({id: 'protocolEditor.tipLifetime.info'})}>
        <span>
          <FmlxIcon name="InfoOutline" size="xs" customColor="white" />
        </span>
      </FmlxTooltip>
      <p className="tip-lifetime-title">{intl.formatMessage({id: 'protocolEditor.tipLifetime.title'})}</p>
    </div>
  );
}

TipLifetime.propTypes = {
  intl: PropTypes.any.isRequired,
};

export default withIntl(TipLifetime);
